import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
import { wechatPay as _wechatPay, wechatConfig, transactions } from "@/api/module/auth";
import { Dialog, Toast } from "vant";
import wx from "weixin-js-sdk";
export default {
  name: "index",
  data: function data() {
    return {};
  },
  created: function created() {
    var _this = this;

    var params = {
      url: location.href.split('#')[0]
    };
    wechatConfig(params).then(function (res) {
      if (res.code == 200) {
        wx.config({
          debug: false,
          // 开启调试模式,
          appId: res.data.appId,
          // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp,
          // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr,
          // 必填，生成签名的随机串
          signature: res.data.signature,
          // 必填，签名，见附录1
          jsApiList: ['checkJsApi', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'translateVoice', 'startRecord', 'stopRecord', 'onRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu', 'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2

        });
        wx.ready(function () {// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          //扫一扫
          // wx.scanQRCode({
          //   needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          //   scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          //   success: function (res) {
          //     var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          //   }
          // });
          //微信支付
          // _this.wechatPay();
        });
      }
    });
  },
  methods: {
    wechatPay: function wechatPay() {
      var _this = this;

      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      var params = {
        openid: userinfo.openid,
        out_trade_no: this.createordernum(),
        amount: 1,
        content: 'demo 体检费',
        attach: '附加信息',
        timeStamp: _this.timestamp,
        nonceStr: _this.nonceStr
      };

      _wechatPay(params).then(function (res) {
        if (res.code == 200) {
          if (res.data != null) {
            console.log(res.data);
            wx.chooseWXPay({
              appId: res.data.appId,
              timeStamp: res.data.timeStamp,
              nonceStr: res.data.nonceStr,
              package: res.data.package,
              signType: res.data.signType,
              paySign: res.data.paySign,
              success: function success(res) {
                // 支付成功后的回调函数
                alert(res.err_msg);
              }
            });
          } else {
            alert("支付异常");
          }
        }
      });

      wx.error(function (res) {
        alert(res.errMsg);
      });
    },
    setTimeDateFmt: function setTimeDateFmt(s) {
      // 个位数补齐十位数
      return s < 10 ? '0' + s : s;
    },
    //生成订单号
    createordernum: function createordernum() {
      var now = new Date();
      var month = now.getMonth() + 1;
      var day = now.getDate();
      var hour = now.getHours();
      var minutes = now.getMinutes();
      var seconds = now.getSeconds();
      month = this.setTimeDateFmt(month);
      day = this.setTimeDateFmt(day);
      hour = this.setTimeDateFmt(hour);
      minutes = this.setTimeDateFmt(minutes);
      seconds = this.setTimeDateFmt(seconds);
      var orderCode = now.getFullYear().toString() + month.toString() + day + hour + minutes + seconds + Math.round(Math.random() * 1000000).toString();
      return orderCode; //基于年月日时分秒+随机数生成订单编号
    },
    jsapiPay: function jsapiPay() {
      var userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      var params = {
        type: "jsapi",
        openid: userinfo.openid,
        outTradeNo: this.createordernum(),
        total: 1,
        description: '诺康云-套餐费',
        currency: 'CNY'
      };
      transactions(params).then(function (res) {
        if (res != null) {
          console.log(res);
          wx.chooseWXPay({
            appId: res.signMap.appId,
            timeStamp: res.signMap.timeStamp,
            nonceStr: res.signMap.nonceStr,
            package: res.signMap.package,
            signType: res.signMap.signType,
            paySign: res.signMap.paySign,
            success: function success(res) {
              // 支付成功后的回调函数
              alert("支付成功后的回调函数" + res.err_msg);
            }
          });
        } else {
          alert("支付异常");
        }
      });
    }
  }
};